import { EventName } from '@lit/react';
import { BlocksCheckboxField } from 'blocks-nextjs/blocks-web-components/components/checkbox-field/checkbox-field';
import { BlocksCheckboxChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatCheckboxField = createComponent({
  react: React,
  tagName: 'cat-checkbox-field',
  elementClass: BlocksCheckboxField,
  events: {
    onBlCheckboxChange: 'bl-checkbox-change' as EventName<BlocksCheckboxChangeEvent>
  }
});
